var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3471",
    "data-name": "Rectangle 3471",
    width: 16,
    height: 16,
    transform: "translate(11173 1182)",
    fill: "#8a8a8a",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_229",
    "data-name": "Mask Group 229",
    transform: "translate(-11173 -1182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(11171.856 1180.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2712",
    "data-name": "Path 2712",
    d: "M14.4,1.143H10.183a.5.5,0,0,0-.35.146l-8.4,8.433a.992.992,0,0,0,0,1.4L5.415,15.14a1.062,1.062,0,0,0,1.55.075l8.282-8.3a.5.5,0,0,0,.146-.35V2.132a.989.989,0,0,0-.99-.99Zm-1.639,3.84a1.1,1.1,0,1,1,.975-.975A1.1,1.1,0,0,1,12.765,4.983Z",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2713",
    "data-name": "Path 2713",
    d: "M16.287,2.868V6.929a.5.5,0,0,1-.146.35L6.882,16.537l.314.314a.992.992,0,0,0,1.4,0L17,8.415a.5.5,0,0,0,.146-.35V3.847a.99.99,0,0,0-.857-.979Z",
    fill: "#8a8a8a",
    opacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.e5cbb1cbc1e09a8d3853f2c7403bcc72.svg";
export { ForwardRef as ReactComponent };